// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { Patient } from '@medplum/fhirtypes';
import type { PharmacyDialogBaseProps } from '@medplum/react';
import { Pharmacies, PharmacyDialog } from '@medplum/react';
import { useScriptSurePharmacySearch } from '@medplum/scriptsure-react';
import type { ComponentType, JSX } from 'react';

interface PharmacySectionProps {
  patient: Patient;
  canEdit: boolean;
}

function ScriptSurePharmacyDialog(props: PharmacyDialogBaseProps): JSX.Element {
  const { searchPharmacies, addToFavorites } = useScriptSurePharmacySearch();

  return <PharmacyDialog {...props} onSearch={searchPharmacies} onAddToFavorites={addToFavorites} />;
}

export function PharmacySection({ patient, canEdit }: PharmacySectionProps): JSX.Element {
  const pharmacyDialogComponent: ComponentType<PharmacyDialogBaseProps> | undefined = canEdit
    ? ScriptSurePharmacyDialog
    : undefined;

  return <Pharmacies patient={patient} pharmacyDialogComponent={pharmacyDialogComponent} />;
}
